<template>
    <section class="order-terms preview">
        <OrderNote
            :model-value="order.notes"
            :order-id="order.id"
            :type="type"
            data-qa="notes"
            note-type="Notes"
        />

        <OrderNote
            :model-value="order.terms"
            :order-id="order.id"
            :type="type"
            data-qa="terms"
            note-type="Terms"
        />

        <div class="mobile">
            <slot />
        </div>
    </section>
</template>

<script>
import OrderNote from './OrderNote.vue';

export default {
    components: {
        OrderNote,
    },

    props: {
        type: {
            type: String,
            options: ['Quote', 'Invoice'],
            default: 'Quote',
        },
        order: {
            type: Object,
            default: () => {
                return {
                    terms: '',
                    notes: '',
                };
            },
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../styles/common';

    .mobile {
        display: none;
    }

    .order-terms {
        padding: 0 $spacing-500;
    }

    @media print {
        .show-all,
        .show-some,
        .accept-order {
            display: none;
        }
    }

    @media only screen and ($small) {
        .order-status-pill,
        .read-only-note {
            display: none;
        }

        .mobile {
            width: 100%;
            display: block;
        }

        .order-terms {
            padding: 0 $spacing-200;
        }
    }
</style>
